"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useGlobalMarkupOptions", {
  enumerable: true,
  get: function () {
    return _useGlobalMarkupOptions.default;
  }
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useGlobalMarkupOptions = _interopRequireDefault(require("./useGlobalMarkupOptions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Component GlobalMarkupOptions accepts an object as `children`, which behaves exactly as the `nlOpts` option to nw-app-module.
 * See https://github.com/NerdWallet/nw-app-module#globalmarkupoptions-component-or-useglobalmarkupoptions-hook for documentation on usage.
 * The component renders nothing.
 *
 * @param {object} children - nlOpts object
 */
const GlobalMarkupOptions = ({
  children
}) => {
  (0, _useGlobalMarkupOptions.default)(children);
  return null;
};

GlobalMarkupOptions.propTypes = {
  children: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

};
var _default = GlobalMarkupOptions;
exports.default = _default;